module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Button-group', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "chevron-left"
    }
  }), _vm._v("\n        Backward\n    ")], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n        Forward\n        "), _c('Icon', {
    attrs: {
      "type": "chevron-right"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3703ec74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/iview-ui/ButtonGroup.vue
// module id = 546
// module chunks = 1